import React, { Component } from 'react'
import styles from './PublishComponent.scss'
import { setHeaderMode } from '@/store/actions/'
import { connect } from 'react-redux'
import { PublishResource } from '@/resources'
import { withTurnPagePlugin } from '@/hocs/withTurnPagePlugin'
import { RenderMagazine } from './RenderMagazine'
import { configurePreview } from '@/utils/configurePreview'
import {defaultPageSize, pageSizeFromProperties} from "../../utils/pageSize";

class PublishComponent extends Component {
  containerRef = null
  state = {
    actualPage: 0,
    background: {
      backgroundColor: '#666'
    },
    pageSize: defaultPageSize,
    scaleFactor: 1,
    start: false
  }

  async componentDidMount () {
    await this.propertiesPage()
    configurePreview( this.state, this.containerRef, state => {
      this.setState( state, () => this.startMagazine() )
    } )

    document.addEventListener( 'click', this.onGoPage )

    /** inicio da gambi pra resolver problema de scroll devido a lib */
    const cssBA = document.getElementById( 'css-builderall-lib' )
    const jsBA  = document.getElementById( 'js-builderall-lib' )

    if( cssBA ) cssBA.remove()
    if( jsBA )  jsBA.remove()
    /** fim da gambi pra resolver problema de scroll devido a lib */
  }

  /**
   * Remove event listener from function
   */
  componentWillUnmount () {
    document.removeEventListener( 'click', this.onGoPage )
  }

  /**
   * Create turn for the page
   * @param {Object} e
   */
  onGoPage = e => {
    const getAttributeHref = e.target.closest( 'a' ) && e.target.closest( 'a' ).getAttribute( 'href' )

    if ( !getAttributeHref || getAttributeHref.indexOf( '#page' ) === -1 ) return false

    e.preventDefault()

    const goPage = getAttributeHref.replace( '#page-', '' )
    this.props.$( '#pages' ).turn( 'page', goPage )
  }

  startMagazine = () => {
    const { pageSize, start } = this.state
    this.props
      .$( '#pages' )
      .turn(
        {
          display: 'double',
          width: pageSize.width * 2,
          height: pageSize.height,
          elevation: 100,
          gradients: true,
          autoCenter: true
        },
        {
          cornerSize: 300
        }
      )
      .bind( 'turning', ( e, page ) => {
        this.setState( {
          actualPage: page
        } )
      } )
    this.setState({start: true})

  }

  propertiesPage = async () => {
    const {
      params: { magazineId }
    } = this.props.match

    const { data: magazine } = await PublishResource.getById( magazineId )

    const properties = JSON.parse( magazine.properties )
    
    if ( !!properties ) this.setState( {
      background: properties,
      pageSize: pageSizeFromProperties(properties)
    } )

    document.title = magazine.title
  }

  navPage = direction => {
    this.props.$( '#pages' ).turn( direction )
  }

  setRef = ref => {
    this.containerRef = ref
  }

  render () {
    const { actualPage, background, scaleFactor, start } = this.state
    const { pages } = this.props

    return (
      <div className={styles.publication}>
        <RenderMagazine
          background={background}
          pages={pages}
          actualPage={actualPage}
          onNavigation={this.navPage}
          setRef={this.setRef}
          scaleFactor={scaleFactor}
          start={start}
        /> 
      </div>
    )
  }
}
export default withTurnPagePlugin(
  connect(
    null,
    { setHeaderMode }
  )( PublishComponent )
)



// WEBPACK FOOTER //
// ./src/components/publish/PublishComponent.js